Ext.define('SA.model.ConditionDeserializer', {
    constructor({modelFactory}) {
        this.modelFactory = modelFactory;
    },

    deserializeCondition(tuple) {
        var isBetweenCondition = tuple[0] === 'and';

        if (isBetweenCondition) {
            let [, gteTuple, lteTuple] = tuple,
                attributeId = gteTuple[1], 
                gteOperand = gteTuple[2],
                lteOperand = lteTuple[2];

            return this.modelFactory.createBetweenCondition({attributeId, gteOperand, lteOperand});
        }

        return this.modelFactory.createUnaryCondition({attributeId: tuple[1], operator: tuple[0], operand: tuple[2]});
    },

    deserializeList(data) {
        if (data === null) {
            return this.modelFactory.createList({operator: 'and', conditions: []});
        }

        var [operator, ...conditionTuples] = data,
            conditions = conditionTuples.map(conditionTuple => this.deserializeCondition(conditionTuple));

        return this.modelFactory.createList({operator, conditions});
    }
});